import React, { useState, useEffect } from 'react';
import './Modal.css';

const treatments = [
    'PRP Hair Restoration',
    'PRP Skin Rejuvenation',
    'Micro-needling',
    'Botox Injectables',
    'Dermal Fillers',
    'Post Hair Transplant Treatments',
];

// ADDED: 'onSuccess' added to the props destructuring here
const AppointmentModal = ({ closeModal, onSuccess }) => {
    const [form, setForm] = useState({
        firstName: '', lastName: '', email: '', phone: '', treatment: '', date: '', message: '',
    });

    useEffect(() => {
        document.body.style.overflow = 'hidden';
        return () => { document.body.style.overflow = ''; };
    }, []);

    const handleChange = e => setForm({ ...form, [e.target.name]: e.target.value });

    const handleSubmit = e => {
        e.preventDefault();

        // UPDATED: Triggers App.js to close this modal and fire up the Thank You modal
        if (typeof onSuccess === 'function') {
            onSuccess();
        } else {
            closeModal();
        }
    };

    return (
        <div className="modal-overlay" onClick={e => e.target === e.currentTarget && closeModal()}>
            <div className="modal-box">
                <button className="modal-close" onClick={closeModal}>×</button>
                <div className="modal-header">
                    <h2>Book Your Appointment</h2>
                    <img src="/assets/Embracelogo.png" alt="Embrace" />
                </div>

                <form onSubmit={handleSubmit} className="modal-form">
                    <div className="form-row">
                        <div className="form-group">
                            <input type="text" name="firstName" value={form.firstName} onChange={handleChange}
                                   placeholder="First Name *" required />
                        </div>
                        <div className="form-group">
                            <input type="text" name="lastName" value={form.lastName} onChange={handleChange}
                                   placeholder="Last Name *" required />
                        </div>
                    </div>

                    <div className="form-row">
                        <div className="form-group">
                            <input type="email" name="email" value={form.email} onChange={handleChange}
                                   placeholder="Email Address *" required />
                        </div>
                        <div className="form-group">
                            <input type="tel" name="phone" value={form.phone} onChange={handleChange}
                                   placeholder="Phone Number" />
                        </div>
                    </div>

                    <div className="form-group">
                        <select name="treatment" value={form.treatment} onChange={handleChange}>
                            <option value="">Select Your Treatment of Interest</option>
                            {treatments.map((t, i) => <option key={i} value={t}>{t}</option>)}
                        </select>
                    </div>

                    <div className="form-group">
                        <input type="date" name="date" value={form.date} onChange={handleChange} />
                    </div>

                    <div className="form-group">
            <textarea name="message" value={form.message} onChange={handleChange}
                      placeholder="Additional notes or questions..." rows="4" />
                    </div>

                    <button type="submit" className="btn-primary modal-submit">
                        Make Appointment
                    </button>
                </form>
            </div>
        </div>
    );
};

export default AppointmentModal;
